
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ai/tender-failures",
      function () {
        return require("private-next-pages/ai/tender-failures.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ai/tender-failures"])
      });
    }
  